import ApiResourceManager from '../ApiResourceManager';
import { TAX_SCOPE } from '../tax-category/TaxCategoriesManager';

/**
 * Same scope trick the tax-category endpoints use: useApiClient always stamps
 * x-on-behalf-of-company once a restaurant is selected, and blanking it makes
 * /tax-settings target the partner's own defaults instead — TaxSettingsRequest
 * on the backend resolves its owner from exactly that header.
 */
const scopeHeaders = (scope) => (scope === TAX_SCOPE.PROVIDER ? { 'x-on-behalf-of-company': '' } : undefined);

export default class TaxSettingsManager extends ApiResourceManager {
  index = ({ scope }) =>
    this.request({
      method: 'GET',
      url: '/tax-settings',
      headers: scopeHeaders(scope),
    });

  update = ({ scope, ...data }) =>
    this.request({
      method: 'PUT',
      url: '/tax-settings',
      data,
      headers: scopeHeaders(scope),
    });

  /**
   * How many restaurants a partner-level behaviour would move. The answer is
   * sent straight back with the save as acknowledged_affected, which the
   * backend recomputes and rejects with a 409 if it has gone stale.
   */
  impact = ({ scope, taxBehaviour }) =>
    this.request({
      method: 'GET',
      url: '/tax-settings/impact',
      // Sent as an empty string rather than omitted when the partner is
      // clearing its default: axios drops null params, and the endpoint has to
      // tell "preview a clear" apart from "you forgot the parameter".
      params: { tax_behaviour: taxBehaviour ?? '' },
      headers: scopeHeaders(scope),
    });
}
